<script>
  import Heading from '../Heading/Heading.svelte';
  import Badge from '../Badge/Badge.svelte';

  export let type = '',
    title = '',
    testid = null;
</script>

<style lang="scss">
  @import '../../styles/tools/media-query';
  @import '../../styles/settings/colors';
  @import '../../styles/settings/core';

  .alert-container {
    display: flex;
    font-size: 1.6rem;
    padding-inline-start: spacing(2);
    padding-inline-end: spacing(2);
    padding-block-start: spacing(2);
    padding-block-end: spacing(2);
    border-radius: spacing(0.5);
    margin-block-end: spacing(2);

    @include mq($from: tabletportrait) {
      margin-block-end: spacing(3);
    }
  }

  .alert-content {
    display: flex;
    align-items: center;
    padding-inline-start: spacing(2);
  }

  .alert-error {
    background-color: $bright-red-10;
    color: $red-50;
  }

  .alert-warning {
    background-color: $yellow-10;
    color: $yellow-90;
  }

  .alert-info {
    background-color: $bright-blue-20;
    color: $blue-40;
  }

  .alert-success {
    background-color: $bright-green-30;
    color: $green-80;
  }

  .text-error {
    color: $red-50;
  }

  .text-warning {
    color: $yellow-90;
  }
</style>

<div class="alert-container alert-{type}" data-testid={testid}>
  <Badge {type} responsive={true} />
  <div class="alert-content">
    <Heading type="title-body" marginBottom="0px" marginBottomDesktop="0px">{title}</Heading>
    <div class="text-{type}">
      <slot />
    </div>
  </div>
</div>
